import { useQuery } from '@tanstack/react-query';
import { ArrowRight, Printer } from 'lucide-react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { Skeleton } from '../../components/ui';
import { apiText } from '../../lib/api';

/** Full-page print view: the API renders the same HTML Chromium uses for the PDF; the browser prints it. */
export function InvoicePrintPage() {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const frame = useRef<HTMLIFrameElement>(null);
  const q = useQuery({ queryKey: ['invoice-html', id, i18n.language], queryFn: () => apiText(`/invoices/${id}/html?lang=${i18n.language === 'en' ? 'en' : 'ar'}`) });
  const print = () => frame.current?.contentWindow?.print();
  return (
    <div className="flex h-full flex-col gap-3">
      <div className="flex items-center gap-2">
        <Link to={`/invoices/${id}`} className="btn-secondary"><ArrowRight size={16} className="rtl:rotate-0 ltr:rotate-180" /> {t('invoices.backToInvoice')}</Link>
        <button className="btn-primary" onClick={print} disabled={!q.data}><Printer size={16} /> {t('invoices.print')}</button>
        <span className="text-xs text-text-faint">{t('invoices.printHint')}</span>
      </div>
      {q.isLoading ? <Skeleton className="h-[80vh]" /> : q.data ? <iframe ref={frame} title={t('invoices.print')} srcDoc={q.data} className="min-h-[80vh] w-full flex-1 rounded-xl border border-border bg-white" onLoad={() => { /* fonts load inside the frame */ }} /> : null}
    </div>
  );
}
